import request from '@/utils/request'

const url = 'admin/baseset.animal'
/**
 * 活畜类型接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Animal
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Animal
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Animal
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 删除Animal
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  }

}

export default api
